module.exports = __webpack_public_path__ + "img/coin.c16bda1e.png";